import { render, staticRenderFns } from "./VmMasterList.vue?vue&type=template&id=3a8cf1b4&scoped=true"
import script from "./VmMasterList.vue?vue&type=script&lang=js"
export * from "./VmMasterList.vue?vue&type=script&lang=js"
import style0 from "./VmMasterList.vue?vue&type=style&index=0&id=3a8cf1b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8cf1b4",
  null
  
)

export default component.exports